<template lang="pug">
  div
    data-title(title="プロジェクト掲載市区町村数")
    div(class="graph")
      img(
        src="~images/Event/Infographics/project_area@2x.png",
        class="image",
        :active="show",
      )
</template>
<script>
  import DataTitle from 'modules/components/Event/Infographics/DataTitle.vue';
  import EventListener from 'modules/mixins/eventListener';

  export default {
    components: {
      DataTitle,
    },
    mixins: [EventListener],
    data() {
      return {
        show: false,
      };
    },
    mounted() {
      this.$listen(window, 'scroll', () => {
        const { innerHeight } = window;
        const { top } = this.$el.getBoundingClientRect();
        if (innerHeight > top + 200) {
          this.show = true;
        }
      });
    },
  };
</script>
<style lang="scss" scoped>
  .graph {
    position: relative;
    text-align: center;
    max-width: 680px;
    width: 100%;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  .image {
    max-width: 404px;
    width: 100%;
    height: auto;
    transform: translateY(30%);
    opacity: 0;
    transition: transform 1s, opacity 1s;
    &[active] {
      transform: translateY(0);
      opacity: 1;
    }
  }
</style>
